export interface Organization {
  id: string;
  name: string;
  address: string;
  email: string;
  website?: string;
  phone?: string;
  is_active?: boolean;
  referral_enabled?: boolean;
  partner_code?: string;
}

export enum InvitationStatusEnum {
  IN_PROGRESS = 1,
  COMPLETE = 2
}
